/* Tiny helper used by the CMS admin pages to load data on mount or when
 * dependencies change without triggering the strict "set-state-in-effect"
 * lint rule. The async loader runs via a microtask so the setState calls
 * happen outside the effect body itself.
 */
import { useEffect } from "react";

export function useDataLoader(loader, deps) {
  useEffect(() => {
    let active = true;
    Promise.resolve().then(async () => {
      if (active) await loader();
    });
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
